import React from 'react';

/*
  Estados posibles: 'oferta' | 'agotado' | undefined (disponible)
  Los productos agotados se envían automáticamente al final.
  Las imágenes deben ser horizontales 16:9 (ej. 1600x900 px).
  Los estilos viven en PisoSpcPremium.css (importado en la página).
*/
const PRODUCTOS = [
  {
    imgSrc: '/assets/img/productos/pisos-spc-premium/marmol-blanco-spc-premium.jpg',
    altText: 'Piso SPC catalogo LQ8105-1',
    codigo: 'MÁRMOL BLANCO',
    tipo: 'Piso SPC Luxury',
    estado: 'oferta',
  },
  {
    imgSrc: '/assets/img/productos/pisos-spc-premium/gris-spc-premium.jpg',
    altText: 'piso luxury catalogo 2010-18',
    codigo: 'GRIS',
    tipo: 'Piso SPC Luxury',
  },
  {
    imgSrc: '/assets/img/productos/pisos-spc-premium/nogal-spc-premium.jpg',
    altText: 'piso spc luxury catalogo 40062-8',
    codigo: 'NOGAL',
    tipo: 'Piso SPC Luxury',
    estado: 'agotado',
  },
  {
    imgSrc: '/assets/img/productos/pisos-spc-premium/marfil-spc-premium.jpg',
    altText: 'piso spc luxury catalogo 33038-022',
    codigo: 'MARFIL',
    tipo: 'Piso SPC Luxury',
    estado: 'agotado',
  },
];

// Disponibles primero, agotados al final (sort estable: respeta el orden original)
const productosOrdenados = [...PRODUCTOS].sort(
  (a, b) => Number(a.estado === 'agotado') - Number(b.estado === 'agotado')
);

const Producto = ({ imgSrc, altText, codigo, tipo, delay, estado }) => {
  const isAgotado = estado === 'agotado';
  const isOferta = estado === 'oferta';

  return (
    <div className="col-12 col-md-6 mt-1-9 wow fadeInUp" data-wow-delay={delay}>
      <div
        className={`card card-style3 spc-card border-0 text-center h-100 ${
          isAgotado ? 'card-agotado' : ''
        }`}
      >
        <div className="card-img spc-img-wrap">
          {isAgotado && (
            <div className="spc-agotado-overlay">
              <span className="spc-agotado-sello">Agotado</span>
            </div>
          )}
          {isOferta && <span className="badge-estado badge-oferta">Oferta</span>}
          <img src={imgSrc} className="spc-img" alt={altText} loading="lazy" />
        </div>
        <div className="card-body p-1-9">
          <h3 className="h5">{codigo}</h3>
          <p className="text-primary spc-tipo mb-0">{tipo}</p>
        </div>
      </div>
    </div>
  );
};

const CatalogoProductoSpcPremium = () => {
  return (
    <section id="catalogo" className="spc-section">
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Catálogo Modelos Piso SPC Luxury</h2>
        </div>
        <div className="row mt-n1-9">
          {productosOrdenados.map((producto, index) => (
            <Producto
              key={producto.codigo}
              {...producto}
              delay={`${(index + 1) * 100}ms`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CatalogoProductoSpcPremium;